import styled, { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H2, H4 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSection = styled.section.withConfig({
  displayName: "WhyLearnSection__StyledSection",
  componentId: "a2vmwh-0"
})(["background-color:", ";padding-block:80px;"], theme.colors.GYPSUM);
const Column = ({
  heading,
  description,
  iconName
}) => {
  return /*#__PURE__*/_jsxs(UIBox, {
    style: {
      maxWidth: '400px'
    },
    children: [iconName && /*#__PURE__*/_jsx("div", {
      className: "m-bottom-3",
      style: {
        color: theme.colors.EERIE
      },
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: iconName,
        size: 50
      })
    }), /*#__PURE__*/_jsx(H4, {
      children: heading
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
const WhyLearnSection = () => {
  const {
    isNotTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(StyledSection, {
    className: "text-center",
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-5",
        style: {
          color: theme.colors.LORAX
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "sprocket",
          size: 40
        })
      }), /*#__PURE__*/_jsx(H2, {
        className: "m-bottom-15",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnSection.title"
        })
      }), /*#__PURE__*/_jsxs(UIFlex, {
        gap: 40,
        justify: "center",
        wrap: isNotTablet ? 'nowrap' : 'wrap',
        children: [/*#__PURE__*/_jsx(Column, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.advanceCareerDescription"
          }),
          heading: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.advanceCareer"
          }),
          iconName: "cap"
        }), /*#__PURE__*/_jsx(Column, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.showSkillsDescription"
          }),
          heading: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.showSkills"
          }),
          iconName: "socialBlockLinkedin"
        }), /*#__PURE__*/_jsx(Column, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.growBusinessDescription"
          }),
          heading: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.growBusiness"
          }),
          iconName: "deals"
        })]
      })]
    })
  });
};
export default WhyLearnSection;